module.exports = __webpack_public_path__ + "img/materials_education_3.db3f5a02.png";